'use strict';
import * as $j_app$002edata$002eorganization$005ftypes$0024package$0024$002dOrganization$002dCopy$002dDocument$002dWatermark$0024 from "./app.data.organization_types$package$-Organization-Copy-Document-Watermark$.js";
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermarkForm$() {
  this.aUr = null;
  this.aUI = null;
  this.aUu = null;
  this.aUv = false;
  this.aUA = null;
  this.aUB = false;
  this.aUG = null;
  this.aUH = false;
  this.aUs = null;
  this.aUt = false;
  this.aUE = null;
  this.aUF = false;
  this.aUC = null;
  this.aUD = false;
  this.aUw = null;
  this.aUx = false;
  this.aUy = null;
  this.aUz = false;
  $n_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermarkForm$ = this;
  this.aUr = $j_app$002edata$002eorganization$005ftypes$0024package$0024$002dOrganization$002dCopy$002dDocument$002dWatermark$0024.$m_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermark$();
  this.aUI = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($j_app$002edata$002eorganization$005ftypes$0024package$0024$002dOrganization$002dCopy$002dDocument$002dWatermark$0024.$m_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermark$());
}
export { $c_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermarkForm$ as $c_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermarkForm$ };
$p = $c_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermarkForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermarkForm$;
/** @constructor */
function $h_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermarkForm$() {
}
export { $h_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermarkForm$ as $h_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermarkForm$ };
$h_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermarkForm$.prototype = $p;
$p.eR = (function() {
  return this.aUr;
});
$p.eO = (function() {
  return this.aUI;
});
$p.bW = (function() {
  if ((!this.aUv)) {
    this.aUu = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aUv = true;
  }
  return this.aUu;
});
$p.b9 = (function() {
  if ((!this.aUB)) {
    this.aUA = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aUB = true;
  }
  return this.aUA;
});
$p.b3 = (function() {
  if ((!this.aUH)) {
    this.aUG = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aUH = true;
  }
  return this.aUG;
});
$p.aG = (function() {
  if ((!this.aUt)) {
    this.aUs = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aUt = true;
  }
  return this.aUs;
});
$p.az = (function() {
  if ((!this.aUF)) {
    this.aUE = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aUF = true;
  }
  return this.aUE;
});
$p.aY = (function() {
  if ((!this.aUD)) {
    this.aUC = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aUD = true;
  }
  return this.aUC;
});
$p.bNb = (function() {
  if ((!this.aUx)) {
    this.aUw = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Copy Document Watermark Text";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aUx = true;
  }
  return this.aUw;
});
$p.bNC = (function() {
  if ((!this.aUz)) {
    this.aUy = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_components_TextKindFor$().zt;
    this.aUz = true;
  }
  return this.aUy;
});
var $d_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermarkForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermarkForm$, "app.data.organization_types$package$OrganizationCopyDocumentWatermarkForm$", ({
  GP: 1,
  N: 1
}));
export { $d_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermarkForm$ as $d_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermarkForm$ };
var $n_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermarkForm$;
function $m_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermarkForm$() {
  if ((!$n_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermarkForm$)) {
    $n_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermarkForm$ = new $c_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermarkForm$();
  }
  return $n_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermarkForm$;
}
export { $m_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermarkForm$ as $m_Lapp_data_organization\uff3ftypes$package$OrganizationCopyDocumentWatermarkForm$ };
//# sourceMappingURL=app.data.organization_types$package$-Organization-Copy-Document-Watermark-Form$.js.map
